const videoPlayerlayerDefaultOpacity = 0.8
const videoPlayerHeroOpacityOverride = (video, overlayOpacity) => {
  // our values need to be multiplied becuse of the difference between the hero opacity selector field value in contentful = 0.15
  // and the calulaton we do inside the video player stylesheet to calculate the comp video opacity value from contentful, 0 - 100
  if (video.opacity === 0) return overlayOpacity * 100

  // if the opacity is unset then add then accumulate the values of comp hero and the default
  // we add '100 -' because the Hero and Video opacities are inversely proportional because
  // the video opacity is the overlay's opacity, hence we need to make the video one directly
  // proportional with the hero one
  if (video.opacity === null)
    return 100 - (overlayOpacity * 100 + videoPlayerlayerDefaultOpacity * 100)

  return video.opacity
}

module.exports = {
  videoPlayerlayerDefaultOpacity,
  videoPlayerHeroOpacityOverride,
}
